import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';

@Component({
  selector: 'app-softwaremodernisierung',
  standalone: true,
  imports: [RouterModule],
  templateUrl: './softwaremodernisierung.component.html',
  styleUrl: './softwaremodernisierung.component.scss'
})
export class SoftwaremodernisierungComponent { }
